import React from 'react';
import Cropper from 'react-easy-crop';
import { Crop, RotateCw, ZoomIn, ZoomOut, Check } from 'lucide-react';

const ASPECT_OPTIONS = [
  { label: '1:1', value: 1 },
  { label: '4:5', value: 4 / 5 },
  { label: '5:4', value: 5 / 4 },
  { label: '3:2', value: 3 / 2 },
  { label: '2:3', value: 2 / 3 },
  { label: '4:3', value: 4 / 3 },
  { label: '3:4', value: 3 / 4 },
  { label: '16:9', value: 16 / 9 },
  { label: '9:16', value: 9 / 16 },
  { label: 'Free', value: 'free' },
];

export const CropControls = ({
  imageSrc, crop, zoom, rotation, aspect,
  onCropChange, onZoomChange, onRotationChange, onCropComplete,
  onAspectChange, onConfirm, accentColor,
}) => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="relative flex-1 min-h-[280px] bg-black">
        <Cropper
          image={imageSrc} crop={crop} zoom={zoom} rotation={rotation}
          aspect={aspect === 'free' ? undefined : aspect}
          onCropChange={onCropChange} onZoomChange={onZoomChange}
          onRotationChange={onRotationChange} onCropComplete={onCropComplete}
        />
      </div>
      <div className="px-5 py-3 space-y-2 border-t border-[#D4AF37]/10" style={{ background: '#0c0c14' }}>
        <div className="flex items-center gap-2 flex-wrap">
          <Crop size={14} className="text-[#D4AF37]/60 flex-shrink-0" />
          <span className="font-['Outfit'] text-xs text-white/30 uppercase tracking-wider mr-1 flex-shrink-0">Ratio</span>
          {ASPECT_OPTIONS.map((opt) => (
            <button key={opt.label} onClick={() => onAspectChange(opt.value)}
              className={`px-3 py-1 rounded-full font-['Outfit'] text-xs font-medium transition-all ${
                aspect === opt.value ? 'bg-[#D4AF37] text-black' : 'border border-white/10 text-white/40'
              }`} data-testid={`aspect-${opt.label}`}>{opt.label}</button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <ZoomOut size={14} className="text-white/30" />
          <input type="range" min={1} max={3} step={0.05} value={zoom}
            onChange={(e) => onZoomChange(Number(e.target.value))} className="flex-1 accent-[#D4AF37] h-1" data-testid="zoom-slider" />
          <ZoomIn size={14} className="text-white/30" />
        </div>
        <div className="flex items-center justify-between">
          <button onClick={() => onRotationChange((rotation + 90) % 360)}
            className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 text-white/60 font-['Outfit'] text-sm font-medium hover:border-[#D4AF37]/30 transition-colors"
            data-testid="rotate-button"><RotateCw size={14} />Rotate</button>
          <button onClick={onConfirm}
            className="flex items-center gap-2 px-6 py-2 rounded-full text-black font-['Outfit'] text-sm font-semibold hover:shadow-[0_0_15px_rgba(212,175,55,0.3)] transition-all"
            style={{ background: accentColor || '#D4AF37' }}
            data-testid="confirm-crop-button"><Check size={16} />Confirm</button>
        </div>
      </div>
    </div>
  );
};
